import { ColumnDefinition } from 'components/shared/resizable-profile-table';

/**
 * The archive's columns, in the live order list's own table so the two read as
 * one app — same header bar, same row height, same drag-to-resize handles.
 * The list itself is far simpler than the order list: no profiles, no sorting,
 * no batch actions, because an archive is searched rather than worked through.
 */
export type HistoricalColumnKey =
    | 'orderDate'
    | 'orderNumber'
    | 'customerName'
    | 'labName'
    | 'patientReference'
    | 'total';

export const HISTORICAL_COLUMN_DEFINITIONS: Record<HistoricalColumnKey, ColumnDefinition<HistoricalColumnKey>> = {
    orderDate: { key: 'orderDate', defaultWidth: 120 },
    orderNumber: { key: 'orderNumber', defaultWidth: 160 },
    customerName: { key: 'customerName', defaultWidth: 220 },
    labName: { key: 'labName', defaultWidth: 200 },
    patientReference: { key: 'patientReference', defaultWidth: 160 },
    total: { key: 'total', defaultWidth: 120 },
};

export const HISTORICAL_COLUMNS: HistoricalColumnKey[] = [
    'orderDate',
    'orderNumber',
    'customerName',
    'labName',
    'patientReference',
    'total',
];

export const HISTORICAL_COLUMN_LABEL_KEYS: Record<HistoricalColumnKey, string> = {
    orderDate: 'orders:ORDER_DATE',
    orderNumber: 'orders:ORDER_NUMBER',
    customerName: 'orders:CLINIC',
    labName: 'orders:LAB',
    patientReference: 'orders:PATIENT_REFERENCE',
    total: 'orders:TOTAL',
};

/**
 * Column widths are not persisted. The order list stores them per saved
 * profile on the user; the archive has no profiles, so a resize lasts the
 * session and costs nothing to get wrong.
 */
export const HISTORICAL_TABLE_PROFILE_ID = 'historical-orders';
